<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Usage by Game" subtitle="Browse and export checkout data by game.">

		<app-content-head-actions-panel v-if="collection.length" text="Export" icon="export" component="manager/common/panel/Export" :data="importexportData" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

		<app-content-filters-check v-model="filter.outliers" text="Exclude Outliers" tooltip="Exclude loans less than 5 minutes and more than 10 hours." />
		<app-content-filters-check v-model="filter.playtowins" text="Exclude Play to Win" tooltip="Exclude Play to Win games." />

		<app-content-filters-select v-model="filter.sort" text="Sort by" prefix="Sort by" tooltip="Change sorting" :options="$util.options(filterSortOptions)" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no loans found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column text="Game" />
				<app-table-column align="center" text="Loans" />
				<app-table-column border="left"  align="center" text="Total Time" subtext="Hours" />
				<app-table-column align="center" text="Average Time" subtext="Hours" />

			</app-table-head>

			<app-table-body>

				<app-table-row :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-text :text="item.name" />
					<app-table-cell-text align="center" :text="item.loans" />
					<app-table-cell-text border="left" align="center" :text="item.time | asHours" />
					<app-table-cell-text align="center" :text="item.average | asHours(2)" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			references: {
				sorts: []
			},
			filter: {
				sort: 'loans',
                outliers: 0,
                playtowins: 0
			},
            filterSortOptions: {
                name: 'Game',
                loans: 'Loans',
                time: 'Total Time',
                average: 'Average Time'
            },
			layout: 'auto 100px 100px 100px',
			endpoint: 'convention/checkout/games',
			live: 'convention/checkout/games'
		}

	},

	computed: {
		
		importexportData: function() {

			return {
				columns: {
					name: 'Game',
                    loans: 'Loans',
                    time: 'Total Time',
                    average: 'Average Time'
				},
				requiredColumns: [],
				valueMapping: {},
				params: this.getParams(),
				index: this.selectedIndex,
				endpoint: this.endpoint
			}

        }

	}

}

</script>

<style scoped>

</style>